import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.slice.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-102104e0"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  id: "article-details"
};
var _hoisted_2 = {
  class: "article-info"
};
var _hoisted_3 = {
  class: "article-title"
};
var _hoisted_4 = {
  class: "article-meta-data-wrap"
};
var _hoisted_5 = {
  class: "article-meta-data"
};

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "article-meta-data-divider"
  }, "|", -1);
});

var _hoisted_7 = {
  class: "article-meta-data"
};

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "article-meta-data-divider"
  }, "|", -1);
});

var _hoisted_9 = {
  class: "article-meta-data"
};
var _hoisted_10 = {
  class: "container"
};
var _hoisted_11 = {
  class: "sticky-layout"
};
var _hoisted_12 = {
  class: "post-body"
};
var _hoisted_13 = ["innerHTML"];
var _hoisted_14 = {
  class: "article-signature"
};
var _hoisted_15 = ["src"];
var _hoisted_16 = {
  class: "copyright"
};
var _hoisted_17 = {
  class: "copyright-item"
};

var _hoisted_18 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "copyright-title"
  }, "文章作者：", -1);
});

var _hoisted_19 = {
  class: "copyright-content"
};
var _hoisted_20 = {
  class: "copyright-item"
};

var _hoisted_21 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "copyright-title"
  }, "文章链接：", -1);
});

var _hoisted_22 = {
  class: "copyright-content"
};
var _hoisted_23 = ["href"];

var _hoisted_24 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "copyright-item"
  }, [/*#__PURE__*/_createElementVNode("span", {
    class: "copyright-title"
  }, "版权声明："), /*#__PURE__*/_createElementVNode("span", {
    class: "copyright-content"
  }, [/*#__PURE__*/_createTextVNode(" 本博客所有文章除特别声明外，均采用 "), /*#__PURE__*/_createElementVNode("a", {
    href: "https://creativecommons.org/licenses/by-nc-nd/4.0/"
  }, "BY-NC-SA"), /*#__PURE__*/_createTextVNode(" 许可协议。转载请注明出处！ ")])], -1);
});

var _hoisted_25 = {
  key: 0,
  class: "article-tags"
};

var _hoisted_26 = /*#__PURE__*/_createTextVNode(" 标签： ");

var _hoisted_27 = {
  class: "previous-next-article"
};
var _hoisted_28 = ["src"];
var _hoisted_29 = {
  class: "previous-article-info"
};

var _hoisted_30 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "label"
  }, "« 上一篇", -1);
});

var _hoisted_31 = {
  class: "title"
};
var _hoisted_32 = ["src"];
var _hoisted_33 = {
  class: "next-article-info"
};

var _hoisted_34 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "label"
  }, "下一篇 »", -1);
});

var _hoisted_35 = {
  class: "title"
};
var _hoisted_36 = {
  id: "article-desc"
};

var _hoisted_37 = /*#__PURE__*/_createTextVNode("编辑");

var _hoisted_38 = {
  key: 1,
  id: "comment-area"
};
var _hoisted_39 = {
  class: "comment-area-title"
};

var _hoisted_40 = /*#__PURE__*/_createTextVNode("评论列表 ");

var _hoisted_41 = {
  id: "comment-items"
};
var _hoisted_42 = {
  id: "comment-form"
};

var _hoisted_43 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    id: "comment-form-title"
  }, "✏️ 发表评论", -1);
});

var _hoisted_44 = {
  id: "comment-editor"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_kila_kila_header = _resolveComponent("kila-kila-header");

  var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");

  var _component_kila_kila_wife_cover = _resolveComponent("kila-kila-wife-cover");

  var _component_kila_kila_admin_card = _resolveComponent("kila-kila-admin-card");

  var _component_kila_kila_catalog_card = _resolveComponent("kila-kila-catalog-card");

  var _component_kila_kila_hot_article_card = _resolveComponent("kila-kila-hot-article-card");

  var _component_kila_kila_side_bar = _resolveComponent("kila-kila-side-bar");

  var _component_router_link = _resolveComponent("router-link");

  var _component_kila_kila_comment_item = _resolveComponent("kila-kila-comment-item");

  var _component_el_pagination = _resolveComponent("el-pagination");

  var _component_mavon_editor = _resolveComponent("mavon-editor");

  var _component_kila_kila_back_to_top = _resolveComponent("kila-kila-back-to-top");

  var _component_kila_kila_light_box = _resolveComponent("kila-kila-light-box");

  var _component_kila_kila_footer = _resolveComponent("kila-kila-footer");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_kila_kila_header), _createVNode(_component_kila_kila_wife_cover, null, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_2, [_createElementVNode("h1", _hoisted_3, [_createTextVNode(_toDisplayString($setup.articleDetails.title) + " ", 1), $setup.isAdmin ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
        key: 0,
        icon: ['fas', 'pen'],
        class: "edit-icon",
        title: "编辑",
        onClick: $setup.editArticle
      }, null, 8, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, [_createVNode(_component_font_awesome_icon, {
        icon: ['fas', 'calendar-days']
      }), _createTextVNode(" 发表于 " + _toDisplayString($setup.articleDetails.createTime), 1)]), _hoisted_6, _createElementVNode("span", _hoisted_7, [_createVNode(_component_font_awesome_icon, {
        icon: ['fas', 'box-archive']
      }), _createTextVNode(" 分类 " + _toDisplayString($setup.articleDetails.categoryName), 1)]), _hoisted_8, _createElementVNode("span", _hoisted_9, [_createVNode(_component_font_awesome_icon, {
        icon: ['fas', 'eye']
      }), _createTextVNode(" 阅读量 " + _toDisplayString($setup.articleDetails.viewCount), 1)])])])];
    }),
    _: 1
  }), _createElementVNode("div", _hoisted_10, [_createVNode(_component_kila_kila_side_bar, null, {
    default: _withCtx(function () {
      return [_createVNode(_component_kila_kila_admin_card), _createElementVNode("div", _hoisted_11, [$setup.articleLoaded ? (_openBlock(), _createBlock(_component_kila_kila_catalog_card, {
        key: 0
      })) : _createCommentVNode("", true), _createVNode(_component_kila_kila_hot_article_card)])];
    }),
    _: 1
  }), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", {
    class: "article-content",
    innerHTML: $setup.articleDetails.content
  }, null, 8, _hoisted_13), _createElementVNode("div", _hoisted_14, [_createElementVNode("img", {
    src: $setup.adminInfo.avatar,
    alt: "头像"
  }, null, 8, _hoisted_15), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_hoisted_18, _createElementVNode("span", _hoisted_19, [_createVNode(_component_router_link, {
    to: "/"
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString($setup.adminInfo.nickName), 1)];
    }),
    _: 1
  })])]), _createElementVNode("div", _hoisted_20, [_hoisted_21, _createElementVNode("span", _hoisted_22, [_createElementVNode("a", {
    href: $setup.articleUrl
  }, _toDisplayString($setup.articleUrl), 9, _hoisted_23)])]), _hoisted_24])]), $setup.articleDetails.tags ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createElementVNode("span", null, [_createVNode(_component_font_awesome_icon, {
    icon: ['fas', 'tags']
  }), _hoisted_26]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.articleDetails.tags, function (tag) {
    return _openBlock(), _createBlock(_component_router_link, {
      to: '/tag/' + tag.id,
      key: tag.id,
      class: "tag-link"
    }, {
      default: _withCtx(function () {
        return [_createTextVNode(_toDisplayString(tag.name), 1)];
      }),
      _: 2
    }, 1032, ["to"]);
  }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_27, [$setup.previousArticle.id ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "previous-article",
    style: _normalizeStyle({
      width: $setup.nextArticle.id ? '50%' : '100%'
    })
  }, [_createVNode(_component_router_link, {
    to: "/article/".concat($setup.previousArticle.id)
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("img", {
        src: $setup.previousArticle.thumbnail,
        alt: "缩略图",
        onErrorOnce: _cache[0] || (_cache[0] = function () {
          return $setup.useDefaultThumbnail && $setup.useDefaultThumbnail.apply($setup, arguments);
        })
      }, null, 40, _hoisted_28), _createElementVNode("div", _hoisted_29, [_hoisted_30, _createElementVNode("div", _hoisted_31, _toDisplayString($setup.previousArticle.title), 1)])];
    }),
    _: 1
  }, 8, ["to"])], 4)) : _createCommentVNode("", true), $setup.nextArticle.id ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "next-article",
    style: _normalizeStyle({
      width: $setup.previousArticle.id ? '50%' : '100%'
    })
  }, [_createVNode(_component_router_link, {
    to: "/article/".concat($setup.nextArticle.id)
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("img", {
        src: $setup.nextArticle.thumbnail,
        alt: "缩略图",
        onErrorOnce: _cache[1] || (_cache[1] = function () {
          return $setup.useDefaultThumbnail && $setup.useDefaultThumbnail.apply($setup, arguments);
        })
      }, null, 40, _hoisted_32), _createElementVNode("div", _hoisted_33, [_hoisted_34, _createElementVNode("div", _hoisted_35, _toDisplayString($setup.nextArticle.title), 1)])];
    }),
    _: 1
  }, 8, ["to"])], 4)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_36, [_createTextVNode(" posted @ " + _toDisplayString($setup.articleDetails.createTime.slice(0, -3)) + " ", 1), _createElementVNode("span", null, _toDisplayString($setup.adminInfo.nickName), 1), _createElementVNode("span", null, "阅读(" + _toDisplayString($setup.articleDetails.viewCount) + ")", 1), _createElementVNode("span", null, "评论(" + _toDisplayString($setup.commentCount) + ")", 1), $setup.isAdmin ? (_openBlock(), _createBlock(_component_router_link, {
    key: 0,
    to: "/article/".concat($setup.articleDetails.id, "/edit")
  }, {
    default: _withCtx(function () {
      return [_hoisted_37];
    }),
    _: 1
  }, 8, ["to"])) : _createCommentVNode("", true)]), $setup.comments.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_createVNode(_component_font_awesome_icon, {
    icon: ['fas', 'comments'],
    class: "comment-icon"
  }), _hoisted_40]), _createElementVNode("div", _hoisted_41, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.comments, function (comment, index) {
    return _openBlock(), _createBlock(_component_kila_kila_comment_item, {
      key: comment.id,
      comment: comment,
      floorNumber: ($setup.currentCommentPageNum - 1) * $setup.commentPageSize + index + 1,
      onReply: $setup.onReplyComment,
      onUpdate: $setup.onUpdateComment,
      onDelete: $setup.onDeleteComment
    }, null, 8, ["comment", "floorNumber", "onReply", "onUpdate", "onDelete"]);
  }), 128))]), $setup.commentCount > 0 ? (_openBlock(), _createBlock(_component_el_pagination, {
    key: 0,
    background: "",
    layout: "prev, pager, next",
    total: $setup.commentCount,
    "page-size": $setup.commentPageSize,
    id: "comment-pagination",
    onCurrentChange: $setup.onCurrentCommentPageChanged
  }, null, 8, ["total", "page-size", "onCurrentChange"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_42, [_hoisted_43, _createElementVNode("div", _hoisted_44, [_createVNode(_component_mavon_editor, {
    modelValue: $setup.commentContent,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return $setup.commentContent = $event;
    }),
    id: "mavon",
    codeStyle: "atom-one-dark",
    autofocus: false,
    boxShadow: false,
    onImgAdd: $setup.onImageAdded,
    ref: "mavonRef",
    placeholder: "发表一条伟大的评论吧~",
    defaultOpen: "edit",
    toolbars: $setup.mavonToolbarOption,
    subfield: false
  }, null, 8, ["modelValue", "onImgAdd", "toolbars"]), _createElementVNode("button", {
    id: "comment-submit-btn",
    onClick: _cache[3] || (_cache[3] = function () {
      return $setup.submitComment && $setup.submitComment.apply($setup, arguments);
    })
  }, _toDisplayString($setup.isInEditMode ? "修改评论" : "提交评论"), 1)])])])]), _createVNode(_component_kila_kila_back_to_top), $setup.articleLoaded ? (_openBlock(), _createBlock(_component_kila_kila_light_box, {
    key: 0,
    ref: "lightBoxRef"
  }, null, 512)) : _createCommentVNode("", true), _createVNode(_component_kila_kila_footer)]);
}